//// Menu principal ////

let navContainer = document.querySelector('.header__navigation');
let navBtn = document.querySelector('.navigation-content__btn');
let navContent = document.querySelector('.navigation-content');
let navMobile = document.querySelector('.header__mobile-hamb');
let closeMenu = document.getElementById('closeMenuMobile');

closeMenu?.addEventListener('click', function(){
    navMobile.classList.remove('active');
    document.querySelector('.menuPrincipalMobile').classList.remove('showMenu');
    enableScroll()
    if(document.querySelector('.menu__border')){
        document.querySelector('.menu__border').style.transform = 'translateX(0)';
    }
    if(document.querySelector('.currentPage')){
        document.querySelector('.currentPage').classList.add('active');
    }
})

navBtn?.addEventListener('click', function(evt){
    navContainer.classList.toggle('active');
    let projectButton = document.querySelector('.project__button');

    if(navContainer.classList.contains('active')){
        disableScroll()
    } else {
        enableScroll()
    }
    
    if(projectButton.classList.contains('active')){
        projectButton.classList.remove('active');
        document.querySelector('.project__form').classList.remove('show');
        document.querySelector('.project').classList.remove('active');
    }
}) 

navContainer?.addEventListener('click', function(evt){
    let targetElement = evt.target;

    if(targetElement == navContainer){
        navContainer.classList.remove('active');
        enableScroll()
    }
})

//Navigation mobile / Menu Hamburger
navMobile?.addEventListener('click', function(){

    let navigation = document.getElementById('nav-menu-mobile');

    if(navMobile.classList.contains('active')){
        enableScroll()
        navMobile.classList.remove('active');
        document.querySelector('.menuPrincipalMobile').classList.remove('showMenu');
        if(document.querySelector('.menu__border')){
            document.querySelector('.menu__border').style.transform = 'translateX(0)';
        }
        if(document.querySelector('.currentPage')){
            document.querySelector('.currentPage').classList.add('active');
        }

    } else {
        disableScroll()
        navMobile.classList.add('active');
        document.querySelector('.menuPrincipalMobile').classList.add('showMenu');
        if(document.querySelector('.currentPage')){
            document.querySelector('.currentPage').classList.remove('active');
        }
        if(document.querySelector('.menu__border')){
            document.querySelector('.menu__border').style.transform = 'translateX(65.3vw)';

        }

    }

    if(document.querySelector('.contactProject') && document.querySelector('.contactProject').classList.contains('active')){
        document.querySelector('.project__button').classList.remove('active');
        document.querySelector('.project__form').classList.remove('show');
        document.querySelector('.project').classList.remove('active');
        document.querySelector('.contactProject').classList.remove('active');
        document.querySelector('.menu__border').style.transform = 'translateX(65.3vw)';
    }
    
}) 


let liItems = document.querySelectorAll('#nav-menu #primary-menu > li.submenu-active > a');
let AllItems = document.querySelectorAll('#nav-menu #primary-menu > li')

liItems?.forEach(function(item){
    
    item.addEventListener('click', function(){
 
        let parent = item.parentNode;
        
        AllItems.forEach(function(i1){
            if(i1 != parent){
                i1.classList.add('inactive')
            }
        })

        if(parent.classList.contains('active')){ 

            parent.classList.remove('active')

            AllItems.forEach(function(i2){
                i2.classList.remove('inactive')
            })

        } else {
            
            parent.classList.add('active')

        }
        
    })
})

//Menu mobile sticky
let scrollPositionTop = window.scrollY;
let headerSticky = document.getElementById('nav-menu-mobile');

window.addEventListener('scroll', function(){

    scrollPositionTop = window.scrollY;

    if(scrollPositionTop >= 200){
        if(headerSticky){  
            headerSticky.classList.add('active');
        }
    } else {
        if(headerSticky){
            headerSticky.classList.remove('active');
        }
    }

})

function disableScroll() {
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.style.height = '100vh';
}

function enableScroll() {
    document.documentElement.style.overflow = '';
    document.documentElement.style.height = '';
}
